export default "__VITE_ASSET__pHC9qsG0__"